var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { of } from "rxjs";
import { combineEpics } from "redux-observable";
import { loadTrafficFiltersActionTypes, loadingTrafficFilters, loadedTrafficFilters, loadFlightControlActionTypes, loadingFlightControl, loadedFlightControl } from "./SearchFilters.ducks.js";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import MdsDataplaneResource from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import IsolationGroupResource from "@ane/exp-data/lib/resources/IsolationGroupResource";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import _ from "lodash";
const loadTrafficFilterArgs = {
  filterOnType: loadTrafficFiltersActionTypes.LOAD,
  loadResource: (payload) => {
    const { workspaceId, managementGroup = "" } = payload;
    const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
    return MdsDataplaneResource.getConfigWithTypeV2({
      workspaceId,
      experimentationGroup,
      section: MasterDataConstants.experimentTrafficFiltersSection
    });
  },
  loadingAction: loadingTrafficFilters,
  loadedAction: (successData, payload, error) => {
    return of(loadedTrafficFilters(payload, getCompletedAsyncWrapperObj(successData, error)));
  }
};
const loadTrafficFiltersEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadTrafficFilterArgs);
const loadFlightControlArgs = {
  filterOnType: loadFlightControlActionTypes.LOAD,
  loadResource: (payload) => {
    const { workspaceId, managementGroup = "" } = payload;
    const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
    return MdsDataplaneResource.getConfigWithTypeV2({
      workspaceId,
      experimentationGroup,
      section: MasterDataConstants.flightControlSection
    });
  },
  loadingAction: loadingFlightControl,
  loadedAction: (successData, payload, error) => {
    return of(loadedFlightControl(payload, getCompletedAsyncWrapperObj(successData, error)));
  }
};
const loadFlightControlEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadFlightControlArgs);
const loadIsolationGroupsActionTypePrefix = "ISOLATION_GROUPS";
const loadIsolationGroupsArgs = {
  actionPrefix: loadIsolationGroupsActionTypePrefix,
  reduxKeyNested: ({ managementGroup }) => ["configByManagementGroup", managementGroup, "isolationGroups"],
  loadResource: ({ managementGroup, workspaceId }) => IsolationGroupResource.getIsolationGroups(managementGroup, workspaceId),
  onCompleteSuccess: (result) => _.reduce(result, (existing, isolationGroup) => __spreadProps(__spreadValues({}, existing), { [isolationGroup.DisplayName]: isolationGroup }), {})
};
const loadIsolationGroupsEpicReducer = loadResourcesUtils(loadIsolationGroupsArgs);
const SearchFiltersEpics = combineEpics(loadTrafficFiltersEpic, loadFlightControlEpic, loadIsolationGroupsEpicReducer.epic);
export {
  SearchFiltersEpics as default,
  loadFlightControlEpic,
  loadIsolationGroupsActionTypePrefix,
  loadIsolationGroupsEpicReducer,
  loadTrafficFiltersEpic
};
//# sourceMappingURL=SearchFilters.epics.js.map
